export function WhaleTypingIndicator() {
  return (
    <span className="wave-whale-typing" aria-label="L'agente sta scrivendo" role="status">
      <span className="wave-whale-typing-dot" />
      <span className="wave-whale-typing-dot" />
      <span className="wave-whale-typing-dot" />
    </span>
  );
}
